import getCookie from './getCookie';
import { CookieName } from './constants';
/**
 * Returns the specified cookie value or undefined (see ./getCookie)
 * @param {Object | string }     context server context
 * @returns {string | undefined} cookie value
 */
var getDfidCookie = function getDfidCookie(context) {
  return getCookie(CookieName.DFID, context);
};
export default getDfidCookie;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/utils/dist/esm/cookies/getDfidCookie.js
// module id = 2633
// module chunks = 11